import { MetaType } from 'store/modules/Meta/types';
import { cutPid } from 'utils';

export const preparePolicies = ({
  policies,
  policyTypes,
  newActionName = 'New policy',
  includeNew = true
}: {
  policies: any;
  policyTypes: Array<MetaType>;
  newActionName?: string;
  includeNew?: boolean;
}) => {
  if (!policies) {
    return includeNew ? [{ name: newActionName, value: 0 }] : [];
  }

  const preparedPolicies = policies.map((policy: any) => {
    const namedPolicyType = policyTypes.filter(
      (type: MetaType) => Number(type.value) === policy.type
    );
    return {
      name: namedPolicyType[0]
        ? `${namedPolicyType[0].name} - ${cutPid(policy.pid)}`
        : policy.number,
      value: policy.id
    };
  });

  if (includeNew) {
    preparedPolicies.unshift({ name: newActionName, value: 0 });
  }

  return preparedPolicies;
};
